module.exports = __webpack_public_path__ + "img/icon_map_61_off_100.c53f046b.png";